import { render, staticRenderFns } from "./CustomerPeriod.vue?vue&type=template&id=2418e881&scoped=true&"
import script from "./CustomerPeriod.vue?vue&type=script&lang=js&"
export * from "./CustomerPeriod.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPeriod.vue?vue&type=style&index=0&id=2418e881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2418e881",
  null
  
)

export default component.exports